const accountClosures = [
	{
		path: '/network/account-closures',
		name: 'network-account-closures',
		component: () => import('@/views/network/account-closures/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,users',
		},
	},
]

export default accountClosures
